import React from 'react';
import { MantineProvider } from '@mantine/core';
import { theme } from './src/theme';
import Layout from './src/components/layout';

import '@mantine/core/styles.css';

// 💡 ΝΕΟ: Εισαγωγή των WordPress Styles για να παίζουν τέλεια τα blocks!
import './src/css/wordpress/style.css';
import './src/css/wordpress/theme.css';
import './src/css/wp-overrides.css'; // Νέο αρχείο για τα δικά σου custom overrides!


export const wrapRootElement = ({ element }) => {
  return <MantineProvider theme={theme}>{element}</MantineProvider>;
};

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};